import { createContext } from 'react'

export interface Session {
  cognitoSub: string
  municipality: string
  municipalityId: number | null
  /** ユーザが所属する自治体の subdomain。非 SYSTEM_ADMIN のホスト名ガードに使う。 */
  municipalitySubdomain: string | null
  /** ユーザが所属する自治体の ocr_use フラグ。SYSTEM_ADMIN など自治体を持たない場合は false。 */
  ocrUse: boolean
  loginId: string
  displayName: string
  /** UserRole の enum key（例: "SYSTEM_ADMIN"）。後端 `/auth/me`・`/auth/login-session` の `role` 値。 */
  role: string
  /** 日本語表示用（例: "システム管理者"）。後端 `roleDisplay` 値。 */
  roleDisplay: string
  /** 後端 DB 由来の権限コード配列（例: ["RECIPIENT_SEARCH", ...]）。 */
  permissions: string[]
  sessionVersion?: number
}

export interface AuthContextValue {
  session: Session | null
  loading: boolean
  login: (payload: Session) => void
  logout: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
